var map = {
	"./3Dian5_1.png": "50ea",
	"./3Dian5_2.png": "8c1f",
	"./3Dian5_3.png": "95f9",
	"./3Dian5_4.png": "6597",
	"./3Dian5_5.png": "9533",
	"./3Dian5_6.png": "15d9",
	"./3Dian5_7.png": "592b",
	"./3Dian5_8.png": "521f",
	"./Lightbrown.png": "51a3",
	"./Pink.png": "4d91",
	"./Purple.png": "fd9d",
	"./anzihong.png": "ae90",
	"./black.png": "bcf0",
	"./black38.png": "a314",
	"./black45.png": "77b0",
	"./blackred.png": "799f",
	"./blue.png": "361b",
	"./caolv.png": "9dd8",
	"./chenghong.png": "1544",
	"./daheilan.png": "ef65",
	"./darkrose.png": "8694",
	"./ganlanlv.png": "195f",
	"./green.png": "8c95",
	"./haijunlan.png": "10e1",
	"./haijunlan2.png": "eb19",
	"./hailan.png": "d77d",
	"./honghe.png": "4058",
	"./huilan.png": "118f",
	"./huilv.png": "3fef",
	"./kafeizong.png": "ddfd",
	"./lanzi.png": "27f0",
	"./liulv.png": "2270",
	"./mitaofei.png": "573b",
	"./moqing.png": "f419",
	"./qingse.png": "0373",
	"./red.png": "7ab4",
	"./shenhese.png": "bbfd",
	"./shenlan.png": "b42b",
	"./shenli.png": "484f",
	"./shenqing.png": "1880",
	"./songlv.png": "c671",
	"./tuhuang.png": "568a",
	"./yellow.png": "f08f",
	"./zhenghuang.png": "23d0",
	"./zifen.png": "46d0",
	"./zilan.png": "971b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e21c";